import { RUN_MODE } from "framework/RCApp";

export const prepareRedirectURL = (rc : any, configuration : any) : URL => {
  const env = rc.initConfig.runMode;
  const PROTOCOL = "https://"
  let ssoBaseURL = "";

  switch(env){
    case RUN_MODE.PROD : 
      ssoBaseURL = `${PROTOCOL}ssoprod.bidgely.com/prod-na`
    break;
    case RUN_MODE.DEV :
      ssoBaseURL = `${PROTOCOL}sso-nonprod.bidgely.com/dev`
    break;
    case RUN_MODE.QA : 
      ssoBaseURL = `${PROTOCOL}sso-nonprod.bidgely.com/qa`
    break;
    case RUN_MODE.UAT :    
      ssoBaseURL = `${PROTOCOL}sso-nonprod.bidgely.com/uat`
    break;
    case RUN_MODE.PRODUCT_QA :    
      ssoBaseURL = `${PROTOCOL}sso-nonprod.bidgely.com/productqa`
    break;
    default:
      ssoBaseURL = `${PROTOCOL}sso-nonprod.bidgely.com/dev`
  }

  const returnURL = encodeURI(`${window.location.origin}`);
  const redirectURL = new URL(ssoBaseURL + `/${configuration.pilotId}UC/saml/login?return_url=${returnURL}`);
  return redirectURL;
}

export function getPopupParams(){
  const width = 600;
  const height = 800
  const left = (window.screen.width / 2) - (width / 2)
  const top = (window.screen.height / 2) - (height / 2)
  const windowParams = `popup=yes, menubar=no, toolbar=no, status=no, resizable=yes, scrollbars=yes, width=${width},height=${height},top=${top},left=${left}`;
  return windowParams;
}